/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC, useContext } from 'react';
import { Linkable } from '@/components/blocks/Linkable';
import { Stack, Typography } from '@mui/material';
import { useLocalization } from '@/data/Localization';
import { UserLogon } from '@/data/Content/Login';
import {
	createAccountButtonSX,
	createAccountButtonTextSX,
	createAccountLabelSX,
} from '@/components/content/Login/styles/button';
import { useForm } from '@/utils/useForm';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useGetOriginPathQuery } from 'integration/hooks/useGetOriginPathQuery';
import { EventsContext } from '@/data/context/events';
import { useLoginOrigin } from '@/data/context/loginOrigin';
import { useSettings } from '@/data/Settings';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';

const initLoginValues: UserLogon = {
	email: '',
	logonPassword: '',
	rememberMe: false,
};
type Props = {
	onSubmit: (value: UserLogon) => void;
};

export const CreateAccountLoginForm: FC<Props> = ({ onSubmit }) => {
	const RouteLocal = useLocalization('Routes');
	const signInNLS = useLocalization('SignIn');
	const router = useNextRouter();
	const origin = useGetOriginPathQuery();
	const { onRegisterBegin } = useContext(EventsContext);
	const login_origin = useLoginOrigin();
	const { settings } = useSettings();

	const { handleSubmit, formRef } = useForm(initLoginValues);

	const noAccountMsg = signInNLS.noAccount.t();

	const handleClickRegister = () => {
		onRegisterBegin({ gtm: { settings, login_origin } });
	};

	return (
		<Stack spacing={2} component="form" onSubmit={handleSubmit(onSubmit)} noValidate ref={formRef}>
			<Stack>
				<Stack alignItems="center" spacing={'13px'}>
					<Typography sx={createAccountLabelSX}>{noAccountMsg}</Typography>
					<DpButton
						href={
							{
								pathname: RouteLocal.Registration.route.t(),
								query: router.query.flow ? { flow: router.query.flow, origin } : { origin },
							} as any
						}
						variant="text"
						sx={createAccountButtonTextSX}
						onClick={handleClickRegister}
					>
						{signInNLS.registerNow.t()}
					</DpButton>
				</Stack>
			</Stack>
		</Stack>
	);
};
